<template>
  <div class="h-level">
    <b-dropdown
      aria-role="list"
      position="is-bottom-left"
      :close-on-click="false"
      v-if="canEdit || canDelete || canOpenInVR"
      @active-change="focused = $event"
    >
      <b-icon slot="trigger" icon="more-horizontal"> </b-icon>
      <b-dropdown-item aria-role="listitem" disabled v-if="canOpenInVR">
        <div class="media">
          <b-icon
            icon="external-link"
            size="is-small"
            class="media-left"
          ></b-icon>
          <span>Open in VR</span>
        </div>
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem" v-if="canEdit">
        <edit-metadata v-bind="$attrs" />
      </b-dropdown-item>
      <b-dropdown-item
        aria-role="listitem"
        :disabled="deleting"
        v-if="canDelete"
      >
        <delete v-bind="$attrs" :deleting="deleting" :focused="focused" />
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import EditMetadata from "@/components/spaces/Modal.Editmetadata";
import Delete from "@/components/spaces/Modal.Delete";
import { bus } from "@/components/spaces/bus.js";
import { PATCH, DELETE } from "@/assets/permissions/actions.type.js";
import * as types from "@/assets/permissions/resources.type.js";
import { mapGetters } from "vuex";

export default {
  components: { EditMetadata, Delete },
  data() {
    return {
      deleting: false,
      focused: false,
      canEdit: false,
      canDelete: false,
      canOpenInVR: false,
    };
  },
  computed: { ...mapGetters(["currentUser"]) },
  watch: {
    currentUser() {
      this.determinePermissions();
    },
  },
  methods: {
    determinePermissions() {
      const { $can, $attrs } = this;
      this.canEdit =
        $can(PATCH, types[$attrs.type.toUpperCase()]) || $can(PATCH, $attrs.id);
      this.canDelete =
        $can(DELETE, types[$attrs.type.toUpperCase()]) ||
        $can(DELETE, $attrs.id);
      this.canOpenInVR = $attrs.actions.includes("vr");
    },
  },
  mounted() {
    this.determinePermissions();
    bus.$on("deleting-event", () => {
      this.deleting = true;
    });
    bus.$on("deleting-complete", () => {
      this.deleting = false;
    });
  },
  beforeDestroy() {
    bus.$off();
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/HLevel.scss";

.addToSpace {
  margin-left: auto;
}

.media {
  font-weight: 400;
}
</style>
